import React, { useMemo } from 'react';
import { reporterSpecialAwardData, ReporterSpecialAwardItem } from '../data/reporterSpecialAwardData';

interface ReporterSpecialAwardModalProps {
  show: boolean;
  onClose: () => void;
  year?: string;
}

const ReporterSpecialAwardModal: React.FC<ReporterSpecialAwardModalProps> = ({ show, onClose, year = '114年度' }) => {
  // 直接從靜態資料取得該年度的所有特殊獎項（與舊版實作方式一致，都是寫死的資料）
  const awardData = useMemo(() => {
    if (!year) return [];
    return reporterSpecialAwardData.filter(item => item.year === year);
  }, [year]);

  // 格式化隊伍資訊（與舊版格式一致）
  // 根據舊版，隊伍資訊格式為：學校名稱 (隊伍編號) 隊伍名稱
  // 如果有學生姓名，則在下一行顯示
  const formatTeamInfo = (specialAward: ReporterSpecialAwardItem) => {
    // 優先使用靜態資料中的完整學校資訊
    const schoolInfo = specialAward.schoolInfo || `(${specialAward.groupno})`;
    
    // 如果有學生姓名，則顯示
    const students = specialAward.students ? `<br/>${specialAward.students}` : '';
    
    return `${schoolInfo}${students}`;
  };

  if (!show) return null;
  return (
    <div className="modal fade show" style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.5)' }} tabIndex={-1} role="dialog" aria-modal="true">
      <div className="modal-dialog max-width-1200 modal-dialog-centered" role="document">
        <div className="modal-content mx-3">
          <div className="modal-header">
            <h5 className="modal-title">{year}報導者特別獎</h5>
            <button type="button" className="btn-close" onClick={onClose} aria-label="Close">
              <span aria-hidden="true" className="text-dark" style={{ fontSize: 36, lineHeight: '12px' }}>&times;</span>
            </button>
          </div>
          <div className="modal-body pb-3" style={{ height: '70vh', maxHeight: 530, overflowY: 'auto' }}>
            <div className="text-dblue p-3 p-md-4" style={{ marginLeft: '40px', marginRight: '40px' }}>
              <p>　　「財團法人報導者文化基金會」是台灣第一個公益基金會成立的網路媒體， 致力於公共領域深度報導， {year === '111年度' ? '今年(2022)推出' : '2022年起推出'}<a href="https://kids.twreporter.org/" target="_blank" rel="noopener noreferrer">「少年報導者」</a>兒少新聞平台，展開與10到15歲的孩子對話。</p>
              <p>　　讓孩子透過資訊探查， 了解社會嚴肅事件的脈絡， 是民主社會重要的事， 透過林玫伶顧問獲悉柯華葳線上探究競賽，《報導者》希望藉由「報導者特別獎」的形式， 彰顯此一活動除具教育意義， 更有提升公民社會的價值。</p>
            </div>
            <h5 className="text-center">【{year}獲獎名單】獎項及獎品提供：財團法人報導者文化基金會</h5>
            
            {awardData.length === 0 && (
              <div className="text-center py-5">
                <p>{year}的報導者特別獎資料準備中...</p>
              </div>
            )}

            {awardData.length > 0 && (
              <>
                {awardData.map((specialAward) => (
                  <div key={`${specialAward.type}-${specialAward.groupno}`} className="card p-2 mx-0 mx-md-3 my-4">
                    <div className="mt-3 me-auto text-second fw-bolder">【{specialAward.type}】</div>
                    <div className="mt-2 mb-3 fw-bold text-primary">{specialAward.specialAwardName}</div>
                    <div className="table-responsive text-start mt-3">
                      <table className="text-sm table table-striped">
                        <tbody>
                          <tr>
                            <td style={{ width: '120px' }}>獲獎隊伍</td>
                            <td className="text-wrap" dangerouslySetInnerHTML={{ __html: formatTeamInfo(specialAward) }}></td>
                          </tr>
                          {specialAward.topic && (
                            <tr>
                              <td style={{ whiteSpace: 'nowrap' }}>探究題目</td>
                              <td className="text-wrap">{specialAward.topic}</td>
                            </tr>
                          )}
                          {specialAward.reason && (
                            <tr>
                              <td>獲獎原因</td>
                              <td className="text-wrap" dangerouslySetInnerHTML={{ __html: specialAward.reason.replace(/\n/g, '<br/>') }}></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ))}
              </>
            )}
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose}>關閉</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReporterSpecialAwardModal; 